import * as actions from "./actions";
import { setModalState as setModalStateTip } from "sites/state/modules/tip/actions";
import { updateWalletBalanc, setUpdatePurchaseMeda } from "sites/state/modules/common/actions";
import { history } from 'sites/state/store';
import { paymentPurchaseUsingWallet, getPurchaseMethods }  from 'sites/api/AuthApi';
import { initWalletPaymentHistoryOperation }  from 'sites/state/modules/wallet/operations';
import { fetchVideoByIdOperation, fetchVideosOperation }  from 'sites/state/modules/videos/operations';
import { fetchPhotosetById, fetchPhotosetsOperation }  from 'sites/state/modules/photosets/operations';
import toast from "common/utils/toast";
import Router from 'sites/routes/router';
import { push } from 'connected-react-router';

export function paymentSend(data, callback, modalData = {}, errorCallback) {
   return async (dispatch) => {
      dispatch(actions.sendRequest());
      dispatch(setUpdatePurchaseMeda({}));
      try {
         const responseData = await paymentPurchaseUsingWallet(data);
         if(responseData.status === 200 && responseData.data && 'wallet_balance' in responseData.data.data) {
            dispatch(updateWalletBalanc(responseData.data.data));
         }
         dispatch(actions.sendCompleted(data, modalData));
         if(history.location.pathname === '/wallet') {
            dispatch(initWalletPaymentHistoryOperation());
         }
         if(data.type === 'video') {
            if(history.location.pathname === '/videos') {
               dispatch(fetchVideosOperation());
            } else {
               dispatch(fetchVideoByIdOperation(data.id));
            }
         }
         if(data.type === 'photoset') {
            if(history.location.pathname === '/photosets') {
               dispatch(fetchPhotosetById(data.id));
            } else {
               dispatch(fetchPhotosetsOperation());
            }
         }
         if(callback) {
            callback()
         }
      } catch (error) {
         if(error && error.response) {
            if(406 === error.response.status) {
               const errorData = error.response.data
               dispatch(actions.sendFailed(error.response, { ...data, ...modalData }));
               if(errorData.data && 'wallet_balance' in errorData.data) {
                  dispatch(updateWalletBalanc(errorData.data));
               }
            } else {
               toast.error('Something went wrong')
               if(errorCallback) {
                  errorCallback()
               }
            }
         }
      }
   };
}


export function fetchPurchaseMethodsOperation(modalType, resourceId, messageType, onlyWalletPay = false, isAddProcessingFees, mainMessageId) {
   return async (dispatch) => {
      if(!['chat_text_message', 'chat_voice_message', 'chat_photo_message', 'multiple_attachment'].includes(modalType)){
         dispatch(actions.setSendModalState({ paymentButtonLoading: true, paymentButtonResourceId: `${ modalType }_${ resourceId }`, mainMessageId }))
      } else {
      }
      try {
         const apiType = {
            membership: 'membership-pricings',
            video: 'videos',
            photoset: 'photosets',
            store: 'products',
            wallet_top_up: 'wallet',
            wallet: 'wallet',
            tip: 'tip',
            messages: 'chat/messages',
            livestream: 'live-stream',
            chat_text_message: 'chat',
            chat_voice_message: 'chat',
            chat_photo_message: 'chat',
         }
         const type = apiType[modalType]
         let modal = modalType;
         if(modalType === 'messages') {
            modal = messageType
         }
         // if(modalType === 'live_stream') {
         //    modal = 'tip'
         // }
         const { data } = await getPurchaseMethods(type, resourceId);
         if(!data.wallet && !data.one_click && !data.another_payment_options){
            dispatch(actions.setSendModalState({ paymentButtonLoading: false, paymentButtonResourceId: null, mainMessageId: null }))
         } else {
            if(!data.wallet && !data.one_click) {
               let path = '';
               switch (modalType) {
                  case 'photoset':
                     path = 'PURCHASE_PHOTOSET';
                     break;
                  case 'video':
                     path = 'PURCHASE_VIDEO';
                     break;
                  case 'tip':
                  case 'video_unlock':
                     path = 'PURCHASE_VIDEO_UNLOCK';
                     break;
                  case 'photo_unlock':
                     path = 'PURCHASE_PHOTO_UNLOCK';
                     break;
                  case 'voice_unlock':
                     path = 'PURCHASE_VOICE_UNLOCK';
                     break;
                  case 'store':
                     path = 'PURCHASE_STORE';
                     break;
                  case 'wallet':
                     path = 'PURCHASE_WALLET';
                     break;
                  case 'livestream':
                     path = 'PURCHASE_LIVE_STREAM';
                     break;
                  default :
                     path = '';
                     break;
               }
               if(path){
                  let param = '';
                  if(type === 'photo_unlock' || type === 'video_unlock') {
                     param = `type=${ type }`;
                  }
                  if(type === 'wallet') {
                     param = `add_processing_fees_to_my_top_up_amount=${ isAddProcessingFees }`
                     dispatch(setModalStateTip({ isTipModal: false }));
                  }

                  dispatch(push({
                     search: param,
                     pathname: Router.route(path).getCompiledPath({ id: resourceId }),
                  }))
                  // dispatch(push(`${ Router.route(path).getCompiledPath({ id: resourceId }) }` + param) /*, param*/);
                  dispatch(actions.setSendModalState({
                     isOpenSendModal: false,
                     isSend: false,
                     isNotEnoughtBalance: false,
                     isOpenChoosePaymentModal: false,
                     modalKey: '',
                     modalType: '',
                     methods: {},
                     paymentButtonLoading: false,
                     paymentButtonResourceId: null,
                     isFetchingModal: false,
                     mainMessageId: null,
                  }))
               }
            } else {
               dispatch(actions.setSendModalState({
                  isOpenChoosePaymentModal: !onlyWalletPay,
                  isOpenSendModal: true,
                  modalType: modal,
                  methods: data,
                  paymentButtonLoading: false,
                  onlyWalletPay: !!onlyWalletPay,
                  paymentButtonResourceId: null,
                  isFetchingModal: false,
                  mainMessageId: null,
               }))
            }

         }
      } catch (error) {
         dispatch(actions.setSendModalState({ paymentButtonLoading: true, paymentButtonResourceId: `${ modalType }_${ resourceId }` }))
         toast.error('Something went wrong')
      }
   };
}
